import { render, staticRenderFns } from "./AboutYourRemortgage.vue?vue&type=template&id=f9e64574&scoped=true&"
import script from "./AboutYourRemortgage.vue?vue&type=script&lang=js&"
export * from "./AboutYourRemortgage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e64574",
  null
  
)

export default component.exports